module.exports = __webpack_public_path__ + "static/img/p2.509a36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/p2.png
// module id = PTGG
// module chunks = 0